import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import personalData from './modules/personal-data';
import gyro from './modules/gyro';
import member from './modules/member';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    personalData,
    gyro,
    member,
  },
});
